import { channelPickerIcons } from '../src/assets/icons/channelPickerIcons/index.js'
import { SingleChannelBehavior } from './enums/single-channel-behavior'
import { handleBackArrow } from '../src/utils/handleBackArrow.js'
import { widgetManager } from '../src/widgetManager/index.js'
import TrueengageLogger from './services/trueengage-logger'
const logger = new TrueengageLogger()
import _ from 'underscore'

export default class ChannelPicker {
  constructor({
    name,
    template,
    onClosed,
    onChannelSelected,
    channels,
    i18n,
    texts,
    widgetId,
    widgetContainer,
    singleChannelBehavior = SingleChannelBehavior.OPEN_CHANNEL,
    channelOrder,
    preInteractionForm,
  }) {
    this.template = template
    this.onClosed = onClosed
    this.onChannelSelected = onChannelSelected
    this.channels = channels
    this.i18n = i18n
    this.texts = texts
    this.widgetId = widgetId
    this.widgetContainer = widgetContainer
    this.visitorId = this.widgetContainer.token
    this.preInteractionForm = preInteractionForm
    this.styleNamespace = name === 'content' ? 'cce-widget__channel-picker' : 'cce-widget__window__footer__menu'
    this.$element = document.createElement('div')
    this.$element.className = this.styleNamespace

    this.channelsOrder = channelOrder
      ? channelOrder.order.filter((item) => item !== 'chatsWrapper')
      : ['faq', 'chat', 'whatsApp', 'facebookChat', 'callUs', 'video', 'callback', 'form', 'meetingSchedule']
    this.singleChannelBehavior = singleChannelBehavior
    const channelsCount = channels.length
    if (channelsCount > 3) {
      try {
        document.querySelector(':root').style.setProperty('--ccew-widget-max-height-add', (channelsCount - 3) * 112 + 'px')
        document.querySelector(':root').style.setProperty('--trueengage-custom-channels', channelsCount)
      } catch (e) {}
    }
  }

  open() {
    logger.debug(`ChannelPicker open scb=${this.singleChannelBehavior}`)
  }

  close() {
    this.toggleState('open', false)
  }

  render() {
    const allChannels = this.getTemplateVariables()

    const chatChannels = ['genesysWhatsapp', 'facebook', 'chat']
    const channelsWithChats = JSON.parse(JSON.stringify(allChannels))
    channelsWithChats.channels = channelsWithChats.channels.filter((channel) => chatChannels.includes(channel.displayType))

    if (channelsWithChats.channels.length > 1 && this.styleNamespace !== 'cce-widget__window__footer__menu') {
      const firstChannelOrder = channelsWithChats.channels[0].order
      channelsWithChats.withoutPrivacy = true
      const channelsWithoutChats = JSON.parse(JSON.stringify(allChannels))
      channelsWithoutChats.channels = channelsWithoutChats.channels.filter((channel) => !chatChannels.includes(channel.displayType))

      const parentElement = this.$element
      const withChatsDiv = document.createElement('div')
      const chatsHeader = document.createElement('div')
      const chatsContent = document.createElement('div')
      const titleSpan = document.createElement('span')
      const subtitleSpan = document.createElement('span')

      const generalTexts = this.texts
        .filter((x) => x.type === 'general')
        .reduce(function (map, obj) {
          map[obj.key] = obj.value
          return map
        }, {})

      titleSpan.className = `${this.styleNamespace}-chats-title`
      titleSpan.innerHTML = generalTexts.groupedChannelsTitle
      subtitleSpan.className = `${this.styleNamespace}-chats-subtitle`
      subtitleSpan.innerHTML = generalTexts.groupedChannelsSubTitle

      chatsHeader.appendChild(titleSpan)
      chatsHeader.appendChild(subtitleSpan)
      chatsHeader.className = `${this.styleNamespace}-chats-header`

      withChatsDiv.appendChild(chatsHeader)
      chatsContent.innerHTML += this.template(channelsWithChats)
      chatsContent.className = `${this.styleNamespace}-chats-content`

      withChatsDiv.appendChild(chatsContent)
      withChatsDiv.className = `${this.styleNamespace}-chats`

      this.$element.innerHTML = this.template(channelsWithoutChats)
      const targetIndex = Math.min(firstChannelOrder, parentElement.children.length)

      const referenceNode = parentElement.children[targetIndex]

      parentElement.insertBefore(withChatsDiv, referenceNode || null)

      this.observeEvents(false)

      if (this.channels.length > 1) {
        this.open()
      }
      return
    }

    this.$element.innerHTML = this.template(this.getTemplateVariables())
    this.observeEvents(this.styleNamespace === 'cce-widget__window__footer__menu')
    if (this.channels.length > 1) {
      this.open()
    }
  }

  getTemplateVariables() {
    let vars = { channels: [], styleNamespace: this.styleNamespace }
    let generalTexts = this.texts
      .filter((x) => x.type === 'general')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})

    const channels = []
    let countActive = 0

    this.channels.forEach((channel) => {
      if (channel.type === 'genesysCallback') {
        if (channel.params.callMeScheduled && !channel.params.callMeNow) {
          channel.eventChannelType = 'callMeLater'
        }
      }

      if (channel.displayType === 'facebook' || channel.displayType === 'chat' || channel.displayType === 'genesysWhatsapp') {
        countActive += 1
      }

      const channelCorrectNamesObj = {
        genesysFaq: 'knowledgeBase',
        genesysFacebookMessenger: 'facebookChat',
        genesysWhatsapp: 'whatsApp',
        genesysVideo: 'video',
        genesysAudio: 'callUs',
        genesysCallback: 'callback',
        genesysWebMessenger: 'chat',
        genesysScheduledVideo: 'scheduleVideo',
        form: 'form',
        meetingSchedule: 'meetingSchedule',
      }
      channel.order = this.channelsOrder.findIndex((channelOrder) => {
        if (channel.type === 'custom') {
          return channelCorrectNamesObj[channel.customName] === channelOrder
        }
        return channelCorrectNamesObj[channel.type] === channelOrder
      })

      channels.push(channel)
    })

    let sortedChannels = _.sortBy(channels, 'order')
    sortedChannels.forEach((item, index) => {
      item.order = index - 1 + 1
    })

    sortedChannels.forEach((channel) => {
      let textType = channel.displayType

      if (textType === 'callMeLater') textType = 'callMeNow'
      if (textType === 'genesysWhatsapp') textType = 'whatsApp'
      if (textType === 'faq') textType = 'knowledgeBase'
      if (textType === 'scheduledVideo') textType = 'scheduleVideo'
      if (channel.customName === 'form') textType = 'customForm'
      if (channel.customName === 'meetingSchedule') textType = 'customMeetingSchedule'

      let startText = this.texts.find((x) => x.type === 'general' && x.key === textType + 'Start')
      const descriptionText = this.texts.find((x) => x.type === 'general' && x.key === textType + 'Description')

      if (countActive > 1 && (textType === 'facebook' || textType === 'chat' || textType === 'whatsApp')) {
        startText = this.texts.find((x) => x.type === 'general' && x.key === (textType === 'whatsApp' ? 'whatsappGroupedStart' : textType + 'GroupedStart'))
      }

      vars.channels.push({
        id: channel.id,
        displayType: channel.displayType,
        eventChannelType: channel.eventChannelType || channel.displayType,
        texts: {
          callToAction: startText ? startText.value : '',
          description: descriptionText ? descriptionText.value : '',
        },
        icon: channel.icon,
        customName: channel.customName || '',
        order: channel.order,
      })
    })

    vars.texts = generalTexts

    vars.icons = channelPickerIcons
    return vars
  }

  toggleState(state, force = false) {
    this.$element.classList.toggle(`${this.styleNamespace}--${state}`, force)
  }

  hasInteractionForm(chatChannel) {
    const chatForm = window.localStorage.getItem('cce-widget-chat-form-data')
    return (
      !chatForm &&
      Object.keys(this.preInteractionForm).length > 0 &&
      this.preInteractionForm.chat.enabled &&
      chatChannel.params.configuration['autoStart'] &&
      chatChannel.params.configuration['autoStart'].toString() !== 'true'
    )
  }

  handleScheduledCallbackView(channel) {
    if (channel.params.callMeNow && channel.params.callMeScheduled) {
      widgetManager.setWidgetTab('trueengage.callback')
    } else if (!channel.params.callMeNow) {
      widgetManager.setWidgetTab('trueengage.callback.schedule')
    } else {
      widgetManager.setWidgetTab('trueengage.callback')
    }
  }

  observeEvents(isChannelPickerFooter) {
    this.$element.querySelectorAll('button[name=openChannel]').forEach((el) => {
      el.addEventListener('click', (e) => {
        const dataset = e.currentTarget.dataset
        const { channelType, customName, channelId, channelEvent } = dataset

        if (channelType === 'custom') {
          widgetManager.setWidgetTab(`trueengage.${customName}`)
          return
        }

        const typeMap = {
          callMeNow: 'callback',
          genesysWhatsapp: 'whatsapp',
          facebook: 'facebookMessenger',
        }

        const resolvedType = typeMap[channelType] || channelType

        if (resolvedType === 'callback') {
          const callbackChannel = this.channels.find((ch) => ch.id === +channelId)
          this.handleScheduledCallbackView(callbackChannel)
          return
        }

        let suffix = ''
        if (resolvedType === 'chat') {
          const chatChannel = this.channels.find((ch) => ch.id === +channelId)
          suffix = this.hasInteractionForm(chatChannel) ? '.pre-interaction-form' : ''
        }

        widgetManager.setWidgetTab(`trueengage.${resolvedType}${suffix}`)
      })
    })

    this.$element.querySelectorAll('button[name=mainMenu]').forEach((el) => {
      el.addEventListener('click', () => {
        widgetManager.setWidgetTab('trueengage.channel_picker')
      })
    })

    if (isChannelPickerFooter) {
      return
    }

    document.querySelector('button[name=ccewBack]').addEventListener('click', () => {
      handleBackArrow(
        this.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL,
        this.channels.find((channel) => channel.displayType === 'callMeNow')?.params.callMeNow
      )
      localStorage.removeItem(`trueengage-activeChannel-${this.widgetId}-${this.visitorId}`)
    })
  }
}
